import { ClinicalTrialTeamPageSlice } from '../ClinicalTrialTeamPage/ClinicalTrialTeamPage.slice';
import { clinicalTrialSlice } from '../clinicalTrial/clinicalTrial.slice';
import { clinicalTrialInventorySlice } from '../clinicalTrialInventory/clinicalTrialInventory.slice';
import { clinicalTrialReportsSlice } from '@restore/clinicalTrialReports/clinicalTrialReports.slice';
import { clinicalTrialsListSlice } from '../clinicalTrialsList/clinicalTrialsList.slice';
import { affiliationUsersListSlice } from '../affiliationUsersList/affiliationUsersList.slice';
import { activateClinicalTrialSlice } from '../activate/activateClinicalTrialSlice';
import { clinicalTrialFiltersSlice } from '@restore/clinicalTrialFilters/clinicalTrialFilters.slice';
import { teamFiltersSlice } from '../teamFilters/teamFilters.slice';
import { usersFiltersSlice } from '../usersFilters/usersFilters.slice';
import { usersListSlice } from '../usersList/usersList.slice';
import { invitationsUserManagementSlice } from '../invitationsUserManagement/invitationsUserManagement.slice';
import { teamMembersListSlice } from '../teamMembersList/teamMembersList.slice';
import { imagingLabelsSlice } from '../imagingLabels/imagingLabels.slice';
import { workflowsSlice } from '@restore/workflows/workflows.slice';
import { questionnairesSlice } from '@restore/questionnaires/questionnaires.slice';
import { pmTaskDefinitionSlice } from '../PMTaskDefinition/PMTaskDefinition.slice';
import { clinicalTrialForms } from '@restore/clinicalTrialForms/clinicalTrialForms.slice';
import { ClinicalTrialTeamPageSaga } from '@restore/ClinicalTrialTeamPage/ClinicalTrialTeamPage.saga';
import { clinicalTrialSaga } from '@restore/clinicalTrial/clinicalTrial.saga';
import { clinicalTrialInventorySaga } from '@restore/clinicalTrialInventory/clinicalTrialInventory.saga';
import { clinicalTrialReportsSaga } from '@restore/clinicalTrialReports/clinicalTrialReports.saga';
import { clinicalTrialsListSaga } from '@restore/clinicalTrialsList/clinicalTrialsList.saga';
import { affiliationUsersListSaga } from '@restore/affiliationUsersList/affiliationUsersList.saga';
import { teamFiltersSaga } from '@restore/teamFilters/teamFilters.saga';
import { usersListSaga } from '@restore/usersList/usersList.saga';
import { invitationsUserManagementSaga } from '../invitationsUserManagement/invitationsUserManagement.saga';
import { teamMembersListSaga } from '@restore/teamMembersList/teamMembersList.saga';
import { imagingLabelsSaga } from '@restore/imagingLabels/imagingLabels.saga';
import { workflowsSaga } from '@restore/workflows/workflows.saga';
import { questionnairesSaga } from '@restore/questionnaires/questionnaires.saga';
import { PMTaskDefinitionsSaga } from '@restore/PMTaskDefinition/PMTaskDefinition.saga';
import { RoleModuleConfig } from './types';
import { facilitesSlice } from '../facilities/facilities.slice';
import { organizationsSlice } from '../organizations/organizations.slice';
import { organizationsSaga } from '../organizations/organizations.saga';
import { facilitiesSaga } from '../facilities/facilities.saga';
import { inventorySlice } from '../inventory/inventory.slice';
import { inventorySaga } from '../inventory/inventory.saga';
import { SponsorOverviewSlice } from '../sponsorOverview/sponsorOverview.slice';
import { sponsorOverviewSaga } from '../sponsorOverview/sponsorOverview.saga';
import { sponsorOverviewFiltersSlice } from '../sponsorOverviewFilters/sponsorOverviewFilters.slice';
import { SponsorEligibilitySlice } from '../sponsorEligibility/sponsorEligibility.slice';
import { sponsorEligibilitySaga } from '../sponsorEligibility/sponsorEligibility.saga';
import { SponsorStatisticsSlice } from '../sponsorStatistics/sponsorStatistics.slice';
import { sponsorStatisticsSaga } from '../sponsorStatistics/sponsorStatistics.saga';
import { auditTrialsSlice } from '../auditTrailsFilters/auditFilters.slice';
import { auditFiltersSaga } from '../auditTrailsFilters/auditFilters.saga';
import { readerTaskSlice } from '../readerTask/readerTask.slice';
import { readerTaskSaga } from '../readerTask/readerTask.saga';
import { readerTaskOrchestrationSlice } from '../readerTaskOrchestration/readerTaskOrchestration.slice';
import { DICOMViewerSlice } from '../DICOMViewer/DICOMViewer.slice';
import { SimpleViewerSlice } from '../DICOMViewer/modes/SimpleViewer/SimpleViewer.slice';
import { clinicalTrialContextSlice } from '../clinicalTrialContext/clinicalTrialContext.slice';
import { ReaderTasksListSlice } from '../ReaderTasks/ReaderTasksList.slice';
import { DXAScoringFormSaga } from '../DXAScoringForm/DXAScoringForm.saga';
import { measurementsSaga } from '../measurements/measurements.saga';
import { DICOMViewerSaga } from '../DICOMViewer/DICOMViewer.saga';
import { SimpleViewerSaga } from '../DICOMViewer/modes/SimpleViewer/SimpleViewer.saga';
import { websocketsSaga } from '../WebSocket.saga';
import { readerSubTaskSaga } from '../readerSubTask/readerSubTask.saga';
import { readerTaskOrchestrationSaga } from '../readerTaskOrchestration/readerTaskOrchestration.saga';
import { ReaderTasksListSaga } from '@restore/ReaderTasks/ReaderTasks.saga';
import { DXAScoringFormSlice } from '../DXAScoringForm/DXAScoringForm.slice';
import { measurementsSlice } from '../measurements/measurements.slice';
import { readerSubTaskSlice } from '../readerSubTask/readerSubTask.slice';
import { formManagementSlice } from '../readerViewerSession/formManagement/formManagement.slice';
import { tabCoordinationSlice } from '../readerViewerSession/tabCoordination/tabCoordination.slice';
import { tabCoordinationSaga } from '../readerViewerSession/tabCoordination/tabCoordination.saga';
import { formManagementSaga } from '../readerViewerSession/formManagement/formManagement.saga';
import { segmentationSlice } from '../segmentation/segmentation.slice';
import { segmentationSaga } from '../segmentation/segmentation.saga';

export const adminModules: RoleModuleConfig = {
  slices: [
    ClinicalTrialTeamPageSlice,
    clinicalTrialSlice,
    clinicalTrialInventorySlice,
    clinicalTrialReportsSlice,
    clinicalTrialsListSlice,
    affiliationUsersListSlice,
    activateClinicalTrialSlice,
    clinicalTrialFiltersSlice,
    teamFiltersSlice,
    usersFiltersSlice,
    usersListSlice,
    invitationsUserManagementSlice,
    teamMembersListSlice,
    imagingLabelsSlice,
    workflowsSlice,
    questionnairesSlice,
    pmTaskDefinitionSlice,
    clinicalTrialForms,
    organizationsSlice,
    facilitesSlice,
    inventorySlice,
    SponsorOverviewSlice,
    sponsorOverviewFiltersSlice,
    SponsorEligibilitySlice,
    SponsorStatisticsSlice,
    auditTrialsSlice,
    clinicalTrialInventorySlice,
    DXAScoringFormSlice,
    measurementsSlice,
    DICOMViewerSlice,
    SimpleViewerSlice,
    readerTaskSlice,
    ReaderTasksListSlice,
    readerSubTaskSlice,
    readerTaskOrchestrationSlice,
    clinicalTrialContextSlice,
    tabCoordinationSlice,
    formManagementSlice,
    segmentationSlice
  ],
  sagas: {
    clinicalTrialSaga,
    ClinicalTrialTeamPageSaga,
    clinicalTrialInventorySaga,
    clinicalTrialsListSaga,
    affiliationUsersListSaga,
    teamFiltersSaga,
    usersListSaga,
    invitationsUserManagementSaga,
    teamMembersListSaga,
    imagingLabelsSaga,
    workflowsSaga,
    questionnairesSaga,
    clinicalTrialReportsSaga,
    PMTaskDefinitionsSaga,
    organizationsSaga,
    facilitiesSaga,
    inventorySaga,
    sponsorOverviewSaga,
    sponsorEligibilitySaga,
    sponsorStatisticsSaga,
    auditFiltersSaga,
    readerTaskSaga,
    DXAScoringFormSaga,
    measurementsSaga,
    DICOMViewerSaga,
    SimpleViewerSaga,
    websocketsSaga,
    ReaderTasksListSaga,
    readerSubTaskSaga,
    readerViewerPageSaga: readerTaskOrchestrationSaga,
    tabCoordinationSaga,
    formManagementSaga,
    segmentationSaga
  },
};
